module.exports = __webpack_public_path__ + "img/river-rock-walk.2b83b58b.webp";